var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "joinModule"
  }, [_vm.isWeixin ? _c('div', {
    attrs: {
      "id": "weixinUI"
    }
  }, [_c('div', {
    attrs: {
      "id": "step1"
    }
  }, [_c('p', [_vm._v("1." + _vm._s(_vm.$t('joinPartyWays.clickMenu')))]), _c('img', {
    attrs: {
      "src": _vm.sjUrl
    }
  })]), _c('div', {
    attrs: {
      "id": "step2"
    }
  }, [_c('p', [_vm._v("2." + _vm._s(_vm.$t('joinPartyWays.openWays')))])])]) : _c('div', {
    attrs: {
      "id": "otherUI"
    }
  }, [_c('div', {
    staticClass: "content",
    class: {
      smallUI: _vm.isAndroid || _vm.isIos
    }
  }, [_c('div', {
    class: {
      smallUI: _vm.isAndroid || _vm.isIos
    }
  }, [_c('div', {
    staticClass: "head"
  }, [_c('img', {
    staticClass: "logoImg",
    attrs: {
      "src": _vm.logoUrl
    }
  }), _c('p', {
    staticClass: "callupTitle"
  }, [_vm._v(_vm._s(_vm.$t('common.callupAnywhere')))])]), _c('p', {
    staticClass: "center h1text"
  }, [_vm._v(_vm._s(_vm.$t('joinPartyWays.notInstallText')))]), _vm.$cm.installApp ? _c('a', {
    attrs: {
      "id": "downloadBtn",
      "href": _vm.downloadUrl
    }
  }, [_vm._v(_vm._s(_vm.$t('joinPartyWays.downLoadFromStore')))]) : _vm._e(), _c('el-divider'), _c('p', {
    staticClass: "h1text"
  }, [_vm._v(_vm._s(_vm.$t('joinPartyWays.hadInstallAnywhereText')))]), _c('a', {
    attrs: {
      "id": "otherJoin"
    },
    on: {
      "click": _vm.joinAnywhereParty
    }
  }, [_vm._v(_vm._s(_vm.$t('joinPartyWays.joinPartyLine')))]), _c('el-divider'), _c('div', [_c('span', {
    staticClass: "h1text macText"
  }, [_vm._v(" " + _vm._s(_vm.$t('joinPartyWays.joinPartyWithBrowser')) + " ")]), _c('a', {
    staticClass: "AccessBtn pointer",
    on: {
      "click": _vm.joinParty
    }
  }, [_vm._v(_vm._s(_vm.$t('joinPartyWays.accessByBrowser')))])])], 1)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };